import { LegalPage, defaultTermsContent } from "@quintara/site-kit";
import { usePageMeta } from "../usePageMeta";
import { useCmsContent } from "../useCmsContent";

export function Terms() {
  const content = useCmsContent("terms", defaultTermsContent);
  usePageMeta(content.meta.title, content.meta.description);
  return <LegalPage content={content} />;
}
